import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CUM, tenPhu } from "../data/glossary.js";

/**
 * Thẻ lật ở đầu /thuat-ngu: chạy qua 10 khái niệm nền (NHAP_MON, đúng thứ tự
 * nên đọc). Mặt trước là thuật ngữ, tự lật sang mặt sau là định nghĩa một câu
 * (shortDef thật trong dữ liệu), rồi sang khái niệm kế tiếp.
 * Chạm thẻ để tự lật; chạm số bên dưới để nhảy tới khái niệm đó (dừng tự chạy).
 * HTML prerender là mặt sau của khái niệm 1: đọc được khi chưa có JavaScript.
 */
export default function ThuatNguLat({ ds }) {
  const [i, setI] = useState(0);
  const [sau, setSau] = useState(true);
  const [chay, setChay] = useState(false);

  useEffect(() => {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    setSau(false);
    setChay(true);
  }, []);

  useEffect(() => {
    if (!chay) return undefined;
    const id = setTimeout(() => {
      if (document.hidden) return;
      if (!sau) setSau(true);
      else { setSau(false); setI((x) => (x + 1) % ds.length); }
    }, sau ? 4200 : 1500);
    return () => clearTimeout(id);
  }, [chay, sau, i, ds.length]);

  if (!ds.length) return null;
  const x = ds[i];
  const phu = tenPhu(x);
  const chon = (j) => { setChay(false); setI(j); setSau(true); };

  return (
    <div className="tnl">
      <div className="tnl-tren">
        <span>Mới bắt đầu? {ds.length} khái niệm nền</span>
        <span className="tnl-dem">{i + 1}/{ds.length}</span>
      </div>
      <button
        type="button"
        className={`tnl-the${sau ? " lat" : ""}`}
        onClick={() => { setChay(false); setSau((v) => !v); }}
        aria-label={sau ? `${x.term}: ${x.shortDef}. Chạm để lật lại` : `${x.term}. Chạm để xem định nghĩa`}
      >
        <span className="tnl-mat tnl-truoc" aria-hidden={sau}>
          <small>Khái niệm {i + 1}</small>
          <b>{x.term}</b>
          {phu && <em>{phu}</em>}
          <span className="tnl-goi-y">Chạm để lật</span>
        </span>
        <span className="tnl-mat tnl-sau" aria-hidden={!sau}>
          <small>{x.term}{phu ? ` (${phu})` : ""}</small>
          <span className="tnl-dinh-nghia">{x.shortDef}</span>
          <span className="tnl-cum">{CUM[x.cum] || ""}</span>
        </span>
      </button>
      <Link className="tnl-mo" to={`/thuat-ngu/${x.slug}`}>Đọc giải thích đầy đủ: {x.term} <span aria-hidden="true">→</span></Link>
      <ol className="tnl-so" aria-label="10 khái niệm nền theo thứ tự nên đọc">
        {ds.map((t, j) => (
          <li key={t.slug}>
            <button type="button" className={j === i ? "dang" : j < i ? "qua" : ""} aria-current={j === i ? "true" : undefined} onClick={() => chon(j)} title={t.term}>
              {j + 1}<span className="sr-only">. {t.term}</span>
            </button>
          </li>
        ))}
      </ol>
    </div>
  );
}
